import { useEffect, useRef, useState } from "react";
import { Button, Grid, Typography } from "@mui/material";
import { UploadFile } from "@mui/icons-material";
import { toast } from "react-toastify";
import CommonDialog from "../../common/commonDialog";
import { importLedgerApExcel } from "../../api/ap_services";

const LedgerApUploadModal = (props) => {
  const { open, onCancel, onImportComplete, setParentLoading } = props;
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    if (!open) {
      setSelectedFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  }, [open]);

  const onFileChosen = (event) => {
    const file = event.target.files?.[0];
    if (!file) {
      setSelectedFile(null);
      return;
    }
    setSelectedFile(file);
  };

  const handleSubmit = () => {
    if (!selectedFile) {
      toast.warning("Please choose an Excel file first.");
      return;
    }
    setParentLoading?.(true);
    importLedgerApExcel(selectedFile)
      .then((res) => {
        setParentLoading?.(false);
        const body = res.response;
        if (body?.responseCode === true) {
          const docs = body.responseMap?.updatedDocumentNumbers;
          if (Array.isArray(docs) && docs.length > 0) {
            const maxShow = 8;
            const shown = docs.slice(0, maxShow).join(", ");
            const suffix =
              docs.length > maxShow
                ? ` (+${docs.length - maxShow} more)`
                : "";
            toast.success(
              `Document number(s) updated successfully: ${shown}${suffix}`,
            );
          } else {
            toast.success(
              body.message || "Updated successfully. No changes found.",
            );
          }
          onImportComplete?.();
          onCancel?.();
        } else {
          toast.error(body?.message || "Import failed");
        }
      })
      .catch(() => {
        setParentLoading?.(false);
        toast.error("Import failed");
      });
  };

  return (
    <CommonDialog
      onCancel={onCancel}
      onSave={handleSubmit}
      open={open}
      primaryButtonLabel="Submit"
      secondaryButtonLabel="Close"
      title="Import Ledger Excel"
      maxWidth="sm"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body2" color="text.secondary">
            Use the exported Ledger report (.xlsx), edit{" "}
            <strong>Vendor Invoice Value</strong> and{" "}
            <strong>Vendor Payment Receipt Value</strong>, then upload. Rows are
            matched by the <strong>ID</strong> column.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <input
            ref={fileInputRef}
            type="file"
            accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            style={{ display: "none" }}
            onChange={onFileChosen}
          />
          <Button
            variant="contained"
            color="primary"
            startIcon={<UploadFile />}
            onClick={() => fileInputRef.current?.click()}
          >
            Choose Excel file
          </Button>
          {selectedFile ? (
            <Typography variant="body2" sx={{ mt: 1 }} display="block">
              Selected: {selectedFile.name}
            </Typography>
          ) : null}
        </Grid>
      </Grid>
    </CommonDialog>
  );
};

export default LedgerApUploadModal;
